import React from 'react';
import TimeTracker from './TimeTracker';
import { motion } from 'framer-motion';
import { useIsOpenedStore } from '../NotificationCenterStore';
import { VARIANTS } from '../constants/variants';
import { Button } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

/**
 * @typedef {object} ItemProps
 * @property {Object} notification
 * @property {(id: number) => void} handleMarkAsReadClick
 */

/**
 * @param {ItemProps} props
 */
const Item = props => {
  const { notification = {}, handleMarkAsReadClick } = props;
  const closeNotificationList = useIsOpenedStore.getState().closeNotificationList;

  return (
    <motion.article
      data-testid='notification-item'
      className='notification-item'
      variants={VARIANTS.ITEM_VARIANT}>
      <div data-testid='notification-icon' className='notification-icon'>
        {notification.icon}
      </div>
      <div className='notification-item-content'>
        <div onClick={closeNotificationList}>{notification.content}</div>
        <TimeTracker createdAt={notification.createdAt} />
      </div>
      <div className='notification-item-actions'>
        {notification.read ? (
          <CheckIcon data-testid='read-icon' />
        ) : (
          <Button
            title='Mark as read'
            onClick={() => {
              handleMarkAsReadClick(notification.id);
            }}>
            <div className='mark-as-read-circle' data-testid='mark-as-read-circle' />
          </Button>
        )}
      </div>
    </motion.article>
  );
};

export default Item;
